import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class UserFeedbackService extends BaseService {
  constructor() {
    super(constants.GET_USER_FEEDBACK_DATA, 'UserFeedbackServiceStatus');
  }

  handleEvent(eventName, event) {
    const { tenantId, ...restPayload } = event.payload;
    const headers = {
      'x-berlin-tenant-id': tenantId
    };
    return this.getClient('evergreen').post(`/userfeedback/table`, restPayload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success' && data?.data?.data?.length > 0) {
      const notification = {
        open: true,
        type: 'success',
        message: 'Data fetched successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('userFeedback').setResponse(response.data);
    } else {
      const notification = {
        open: true,
        type: 'info',
        message: 'No Data Found'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('userFeedback').setResponse(response);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
